import { render, staticRenderFns } from "./UsuariosNuevo.vue?vue&type=template&id=ef5cd450&scoped=true"
import script from "./UsuariosNuevo.vue?vue&type=script&lang=js"
export * from "./UsuariosNuevo.vue?vue&type=script&lang=js"
import style0 from "./UsuariosNuevo.vue?vue&type=style&index=0&id=ef5cd450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5cd450",
  null
  
)

export default component.exports